<header>
  <h1 class="sm-text-xl sm-font-medium sm-flex sm-flex-1" i18n>Apply list item colours</h1>
  <button
    class="header-control"
    type="button"
    aria-label="Cancel list creation."
    (click)="cancelApplyListRowStyles()"
    data-test="close-button"
  >
    <em class="cc-icon cc-icon-close" aria-hidden="true"></em>
  </button>
</header>

<div class="sm-text-center">
  <p>Select the colour you wish to apply to the selected list items. The colour applied to the selected list items will also be displayed in forms and PDF exports.</p>
  <br />
  <p>Note: Deployed list items will need to be updated in the parent list.</p>
</div>

<form (submit)="applyListItemColours($event)">
  <cc-style-color-picker
    class="sm-w-full"
    [(style)]="style"
    mode="select"
  ></cc-style-color-picker>
  <div class="form-controls">
    <button
      class="cancel-button"
      type="button"
      (click)="cancelApplyListRowStyles()"
    >
      Cancel
    </button>
    <button
      class="apply-button"
      type="submit"
      [attr.aria-disabled]="isSaving || !style"
      [class.disabled]="isSaving || !style"
    >
      Apply
    </button>
  </div>
</form>
